<template>
  <v-select 
    class="style-chooser"
    v-if="isSearchMode==true && searchModeTypeahead == true" 
    style="font-size: 12px!important;"
    :clearable="false"
    :options="fieldOptions"
    :single-line="true"
    :value="fieldValue"
    @input="updateValue"
  >
   <template slot="no-options" >
      対象はありません
    </template>
  </v-select>
  <select
    v-else-if="isSearchMode==true"
    :style="filedStyle"
    :class="{'form-control':true, 'select-box':true,'limited-height-box':isSearchMode==true}"
    :disabled="isDisabled"
    v-on:change="updateValue($event.target.value)"
    v-bind:id="fieldID"
    v-bind:name="fieldID"
    v-bind:value="fieldValue"
    v-on:click="onClick"
  >
    <option></option>
    <option
      v-for="o in fieldOptions"
      :selected="o==fieldValue"
      v-bind:data="o"
      v-bind:key="o"
      :value="o"
      val="."
    >{{specialLabels(o)}}</option>
  </select>
  <div
    v-else
    :class="{'form-group':isSearchMode==false, 'esma_form_group':isSearchMode==false}">
    <label
      v-if="showLabel && isSearchMode == false"
      v-bind:for="fieldID"
      :class="{'col-xs-4':true, 'control-label':true, 'esma_form_label':true,'esma_error_field':showAsError}"
    >{{fieldLabel}} <span v-if="isRequired" class="is_required" aria-hidden="true">＊</span></label>
    <div :class="fieldClass + ' select-box4'" style="padding:1px 0px 1px 7px;">
      <select
        :style="filedStyle"
        :class="{'form-control':true, 'select-box':true,'limited-height-box':isSearchMode==true}"
        :disabled="this.isLoading || isDisabled"
        v-on:change="updateValue($event.target.value)"
        v-bind:id="fieldID"
        v-bind:name="fieldID"
        v-bind:value="fieldValue"
        v-on:click="onClick"
      >
        <option v-if="disallowFirstEmptyOption == false"></option>
        <option
          v-for="o in fieldOptions"
          :selected="o==fieldValue"
          v-bind:data="o"
          v-bind:key="o"
          :value="o"
          val="."
        >{{specialLabels(o)}}</option>
      </select>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { bus } from "@/libs/bus";
import debug from "debug";
import _ from "lodash";
import uuid from "uuid";
import constants from '../../rules/constants';
var debug_select = debug("__esma:select-box");


import vSelect from "vue-select";
import "../../../node_modules/vue-select/dist/vue-select.css";
export default {
  components: {
    'v-select':vSelect
  },
  data() {
    return {
      local_options: [],
      selection_rules: false,
      listen_for: false,
      forced_options: null,
      value_updated: false,
      field_options: [],
      original_field_options: [],
      cache_for_disable_and_clean_if_value:false,
      local_disabled:false,
      last_search_value:false,
      local_refresh_sequecnce: 1,
      show_as_error:false,
      page_controller_on_select:false,
      local_data_loaded:false,
      is_loading:false,
      disabled_is_required:false,
      external_disabled:false,
      force_edit:false,
      current_user:"",
      ignore_values:[]

    };
  },
   computed: {
     ignoreValues:{
       get(){
         return this.ignore_values;
       },
       set(v){
         this.ignore_values = v;
       }
     },
     currentUser:{
       get(){
         return this.current_user;
       },
       set(v){
         this.current_user = v;
       }
     },
     forceEdit:{
       get(){
         return this.force_edit;
       },
       set(v){
         this.force_edit = v;
       }
     },
    isNoAdminUserId(){
      var role = Vue.localStorage.get("userRole")
      return role == "管理担当者" || role == "管理責任者";
    },
    externalDisabled:{
      get(){
        return this.external_disabled;
      },
      set(v){
        this.external_disabled = v;
      }
    },
    disabledIsRequired:{
      get(){
        return this.disabled_is_required;
      },
      set(v){
        this.page_controller_disable_propagate  = true;
        var local_val = _.clone(this.$store.state[this.stateCurrentEditing][this.fieldID]);
        if(typeof local_val == "undefined"){
          local_val = _.clone(this.$store.state[this.stateCurrentRow][this.fieldID]);
        }
        this.disabled_is_required = v;
        this.$store.state[this.stateCurrentRow][this.fieldID] = local_val;
        this.updateValue(local_val);
        this.localRefreshSequecnce++;
        this.page_controller_disable_propagate  = false;
      }
    },
    searchModeTypeahead(){
      return this.$props.data.search_mode_type_ahead || false
    },
     isLoading:{
       get(){
         return this.is_loading;
       },
       set(v){
         this.is_loading = v;
       }
     },
     isRequired(){
      return this.localRefreshSequecnce > 0 && this.disabledIsRequired == false && (this.$props.data.error_if_blank || false);
    },
     showAsError:{
       get(){
         return this.show_as_error;
       },
       set(v){
         this.show_as_error = v;
       }
     },
     localRefreshSequecnce:{
       get(){
         return this.local_refresh_sequecnce;
       },
       set(v){
         this.local_refresh_sequecnce = v;
       }
     },
     disallowFirstEmptyOption(){
       if(typeof this.$props.data.allow_first_empty_option == "undefined"){
         return true;
       }
       return this.$props.data.allow_first_empty_option != true
     },
    localDisabled:{
      get(){
        return this.local_disabled;
      },
      set(v){
        this.local_disabled = v;
      }
    },
    filedStyle() {
      var store_style = this.$store.state[this.stateCurrentRow.replace("current_row","current_field_style")][this.fieldID] || ";color:black;";
      return (this.$props.data.field_style || "") + store_style;
    },
    stateCurrentRow(){
      if(typeof this.$props.data.state_current_row != "undefined"){
        return this.$props.data.state_current_row;
      }else{
        return "current_row";
      }
    },
    stateCurrentEditing(){
      if(typeof this.$props.data.state_current_editing != "undefined"){
        return this.$props.data.state_current_editing;
      }else{
        return "current_editing";
      }
    },
    stateIsEditingNew(){
      if(typeof this.$props.data.state_is_editing_new != "undefined"){
        return this.$props.data.state_is_editing_new;
      }else{
        return "is_editing_new";
      }
    },
    fieldTableName() {
      return this.$props.data.table_name;
    },

    originalFieldOptions: {
      get() {
        return this.original_field_options;
      },
      set(v) {
        this.original_field_options = v;
      }
    },
    fieldLabel() {
      return this.$props.data.label;
    },
    fieldValue() {
      if(this.isSearchMode){
        if(this.last_search_value != false){
          return this.last_search_value;
        }
        if(typeof this.$props.search_value == "string" && this.$props.search_value.length > 0 ){
          return this.$props.search_value;
        }
        return "";
      }
      var val = this.$store.state[this.stateCurrentRow][this.fieldID];
      this.fieldOptions = _.clone(this.originalFieldOptions);
      if (this.fieldOptions.indexOf(val) < 0) {
          this.fieldOptions.unshift(val);
      }
      // if(this.fieldOptions.indexOf("") < 0){
      //   this.fieldOptions.push("");
      // }
      if(typeof this.$props.data.event_emit_bus_key == "string" && this.$props.data.event_emit_bus_key.length > 0 ){
        setTimeout(()=>{
          bus.$emit(this.$props.data.event_emit_bus_key,{val:this.$store.state[this.stateCurrentRow][this.fieldID]})
        },500)
      }
      return (this.localRefreshSequecnce > 0) ?this.$store.state[this.stateCurrentRow][this.fieldID]:"";
    },
    fieldID() {
      return this.$props.data.id;
    },
    fieldClass() {
      if (this.getOption("hide_label", false) == true) {
        return "col-xs-12";
      } else {
        return "col-xs-8";
      }
    },
    showLabel() {
      if (this.getOption("hide_label", false) == true) {
        return false;
      } else {
        return true;
      }
    },
    isSearchMode() {
      if (this.getOption("search_mode", false) == true) {
        return true;
      } else {
        return false;
      }
    },
    isSearchBlockID() {
      return parseInt(this.getOption("search_block_id", false) || -1)
    },
    isDisabled() {
      var ret = null;
      if(this.isSearchMode == true){
        return false;
      }
      if(this.forceEdit == true){
        return false;
      }
      if (this.$store.state[this.stateIsEditingNew] == true) {
        ret = this.isLoading || this.externalDisabled || this.localDisabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined"; //TODO, can also has another field to force it.
      } else {
        ret =  this.isLoading || this.externalDisabled || this.localDisabled || this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined";
      }
      if (ret == false) {
        if(this.local_data_loaded == false){
          this.load_local_data()
        }
        this.checkToApplySelectionRules( this.$store.state[this.stateCurrentRow][this.fieldID]);
      }
      return ret;
    },
    fieldOptions: {
      get() {
        if(this.$props.data.page_controller == true && this.isSearchMode != true){
          if(this.$props.data && this.$props.data.page_controller_use_key_name == true){
            var temp = this.field_options || [];
            var temp2 = [];
            if (typeof this.$props.data.api_field_name != "undefined" && this.$props.data.api_field_name.length > 0) {
              temp2 = temp.map(o => {
                var r = o[this.$props.data.api_field_name] || "";
                return _.trim(r);
              });;
            }else{
              temp2 = temp.map(o => {
                return  _.trim(o.val || "") ;
              });;
            }
            if (this.$props.data.sort_result == true) {
              temp2 = _.sortBy(temp2,(d)=> {return d.toLowerCase() })
            }
          return temp2;
        }else{
          if (this.$props.data.sort_result == true) {
            return _.sortBy(this.field_options,(d)=> {return d.toLowerCase() })
          }else{
            return this.field_options;
          }
        }
      }
        // if(this.$props.data.force_page_controller == true){
        //   if(this.field_options && (this.field_options[0] && typeof this.field_options[0].val != "undefined")){
        //     return this.field_options.map(v => { return v.val})
        //   }else{
        //     return [];
        //   }
        // }
        var temp = this.field_options || [];
        if(this.isSearchMode == true){
          var found_as_dependency = false
          if(this.$props.data && this.$props.data.search_dependency){
              var sd = this.$props.data.search_dependency;
              if(sd.algorithm == "company"){
                var search_data = this.$store.state.search_data;
                if(this.fieldID == sd.fields.company){
                  // If it is the companny there are nothing to do
                }
                // Filter by the company
                if(this.fieldID == sd.fields.department.field || this.fieldID == sd.fields.team.field){
                  found_as_dependency = true
                  // If it is the department , need to find if there are company at others.
                  var companies = this.loadFromSearch(sd.fields.company.field)
                  var temp2 = temp;
                  if(companies.length == 1){
                    temp2 = _.filter(temp,(obj) =>{ return obj[sd.fields.company.api] == companies[0].value})
                  }else if(companies.length == 2){
                    temp2 = _.filter(temp,(obj) =>{ return obj[sd.fields.company.api] == companies[0].value || obj[sd.fields.company.api] == companies[1].value; })
                  }
                  temp = temp2;
                }
                // Filter by deparment
                if(this.fieldID == sd.fields.team.field){
                  found_as_dependency = true
                  var departments = this.loadFromSearch(sd.fields.department.field)
                   var temp2 = temp;
                  if(departments.length == 1){
                    temp2 = _.filter(temp,(obj) =>{
                      return obj[sd.fields.department.api] == departments[0].value
                      })
                  }else if(departments.length == 2){
                    temp2 = _.filter(temp,(obj) =>{ return obj[sd.fields.department.api] == departments[0].value || obj[sd.fields.department.api] == departments[1].value; })
                  }
                  temp = temp2;
                }
              }
          }
          if( found_as_dependency == false && this.$props.data.search_limit_no_admin_company_from_local_storage == true){
            var user_company = Vue.localStorage.get("userCompany");
            if(user_company != constants.COMPANY.ALL && user_company && user_company.length > 0 && this.isNoAdminUserId){
              temp = [{val:user_company}]
            }
          }else if (found_as_dependency == false &&   typeof this.$props.data.search_option != "undefined" && typeof this.$props.data.search_option.define_department_limit_by_key != "undefined") {
            if(this.$store.state.define_department_limit != false){
              if(this.$store.state.define_department_limit.by_key == this.$props.data.search_option.define_department_limit_by_key){
                var temp2 = _.filter(temp,(obj) =>{
                  return obj[this.$props.data.search_option.api_field_name] == this.$store.state.define_department_limit.val;
                })
                temp = temp2;
              }
            }
          }
        } else {
          // It do  not applye for search
          if (typeof this.$props.data.api_filter_to_other_field != "undefined"){
            if ( typeof this.$props.data.api_filter_to_other_field.by_field != "undefined" && typeof this.$props.data.api_filter_to_other_field.compare_api_key != "undefined") {
              var by_field = this.$props.data.api_filter_to_other_field.by_field || "";
              var compare_api_key = this.$props.data.api_filter_to_other_field.compare_api_key|| "";
              if ( by_field.length > 0 && compare_api_key.length > 0) {
                // Get current value
                var current_value = "";
                if(typeof this.$store.state[this.stateCurrentRow] != "undefined"  && typeof this.$store.state[this.stateCurrentRow][by_field] != "undefined"   &&  this.$store.state[this.stateCurrentRow][by_field] != null && this.$store.state[this.stateCurrentRow][by_field].length > 0){
                  current_value = this.$store.state[this.stateCurrentRow][by_field];
                }
                if(typeof this.$store.state[this.stateCurrentEditing] != "undefined" && typeof this.$store.state[this.stateCurrentEditing][by_field] != "undefined" && this.$store.state[this.stateCurrentEditing][by_field] != null && this.$store.state[this.stateCurrentEditing][by_field].length > 0){
                  current_value = this.$store.state[this.stateCurrentEditing][by_field];
                }
                // Compare
                if(current_value.length > 0){
                  temp = _.filter(temp,o => {
                    return o[compare_api_key] == current_value;
                  });
                }
              }
            }
          }
        }
        if(this.stateIsEditingNew){
          if(typeof this.$props.data.default_from_local_storage != "undefined"){
            var default_val = Vue.localStorage.get(this.$props.data.default_from_local_storage);
            if(default_val == constants.COMPANY.ALL){
              default_val = "";
            }
            if(this.isNoAdminUserId == false && this.isSearchMode == true){
              default_val = "";
            }
            if(default_val && default_val.length > 0 && this.value_updated == false){
              setTimeout(()=>{
                  if(this.fieldValue == ""){
                    this.updateValue("");
                    this.$store.state[this.stateCurrentRow][this.fieldID] = default_val;
                    this.updateValue(default_val);
                    this.refreshOptions();
                  }
              },200);
            }
          }
        }

        var temp2 = [];
        if (typeof this.$props.data.api_field_name != "undefined" && this.$props.data.api_field_name.length > 0) {
          temp2 = temp.map(o => {
            var r = o[this.$props.data.api_field_name] || "";
            return _.trim(r);
          });;
        }else{
          temp2 = temp.map(o => {
            return  _.trim(o.val || "") ;
          });;
        }
        if (this.$props.data.sort_result == true) {
          temp2 = _.sortBy(temp2,(d)=> {return d})
        }
        var i = 0
        var removed = _.remove(temp2,(d)=> { return  typeof d == "undefined" || d == "" || d == null || d == undefined})

        if(Array.isArray(this.$props.data.do_not_repeat) && this.$props.data.do_not_repeat.length > 0){
          this.$props.data.do_not_repeat.forEach(dnr =>{
            var dnr_v = this.$store.state[this.stateCurrentEditing][dnr];
            if(this.forceEdit == true && !(dnr_v && dnr_v.length > 0)){
              dnr_v = this.$store.state[this.stateCurrentRow][dnr];
            }
            if(dnr_v && dnr_v.length > 0){
              _.remove(temp2,(t)=>{ return t == dnr_v;})
            }
          })
        }
        if(this.$props.data.ignore_current_user == true){
          _.remove(temp2,(t)=>{ return t == this.currentUser;})
        }
        if(Array.isArray(this.ignoreValues) && this.ignoreValues.length > 0){
          _.remove(temp2, (t)=>{ return this.ignoreValues.indexOf(t) > -1;})
        }
        if (this.$props.data.api_uniq_grouping == true) {
          return _.uniq(temp2);
        }else{
          return temp2;
        }
      },
      set(v) {
        this.field_options = v;
      }
    },
    },
  methods: {
    loadFromSearch(field_id){
      var search_data = this.$store.state.search_data;
      var ret = []
      if(search_data[1] && search_data[1].field == field_id){
        ret.push(search_data[1])
      }
      if(search_data[2] && search_data[2].field == field_id){
        ret.push(search_data[2])
      }
      if(search_data[3] && search_data[3].field == field_id){
        ret.push(search_data[3])
      }
      return ret;
    },
    specialLabels(v) {
      if(v && v.length > 0){
          if (typeof this.$props.data.field_label_reference != "undefined" && 
            this.$props.data.field_label_reference.length > 0 &&
            this.$store.state[this.stateCurrentRow][this.fieldID] == v &&
            typeof this.$store.state[this.stateCurrentRow][this.$props.data.field_label_reference]  != "undefined"  && 
            this.$store.state[this.stateCurrentRow][this.$props.data.field_label_reference]  && 
            this.$store.state[this.stateCurrentRow][this.$props.data.field_label_reference].length > 0
            ){
            return this.$store.state[this.stateCurrentRow][this.$props.data.field_label_reference];
          }
      }
      if (typeof this.$props.data.api_field_label != "undefined" && this.$props.data.api_field_label.length > 0 &&
      typeof this.$props.data.api_field_name != "undefined" && this.$props.data.api_field_name.length > 0) {
        var val = _.find(this.originalFieldOptions,(o)=>{
          return o[this.$props.data.api_field_name] == v
        })
        return _.get(val,[this.$props.data.api_field_label] ,v);
      }else{
        return v;
      }
    },
    onClick(d) {
      if(this.$props.data.emit_click_event == true){
        var val = false;
        if(this.$store.state[this.stateCurrentEditing][this.fieldID]){
          val = this.$store.state[this.stateCurrentEditing][this.fieldID]
        }else if(this.$store.state[this.stateCurrentRow][this.fieldID]){
          val = this.$store.state[this.stateCurrentRow][this.fieldID]
        }
        if(val && (val+"").length > 0){
          this.updateValue(val)
        }
      }

    },
    updateValue(d) {
      debug_select("updateValue", d);
        if(this.$props.data && this.$props.data.search_dependency){
          var sd = this.$props.data.search_dependency;
          if(Array.isArray(sd.clear_on_reset) && sd.clear_on_reset.length > 0){
            sd.clear_on_reset.forEach(csd =>{
              bus.$emit("onSearchClearById",{field_id:csd, block_id: this.isSearchBlockID})
            })
          }
        }
      this.value_updated = true;

      if(this.$props.data.emit_input == true){
        this.$emit("on_update",{field:this.fieldID,val:d});
      }
      if (typeof this.$props.data.global_emit != "undefined") {
        bus.$emit(this.$props.data.global_emit, d);
      }
      if(this.isSearchMode== true){
        this.$emit("change",d);
        this.last_search_value = d;
      }else{
        this.$store.state[this.stateCurrentEditing][this.fieldID] = d;
        this.checkToApplySelectionRules(d);
      }

      if(this.isSearchMode == true){
        if (typeof this.$props.data.search_option != "undefined" && typeof this.$props.data.search_option.define_department_limit_to_key != "undefined") {
          this.$store.state.define_department_limit = {
            by_key: this.fieldID,
            val: d
          }
        }
      }
      if(typeof this.$props.data.on_select_event_emit_bus_key == "string" && this.$props.data.on_select_event_emit_bus_key.length > 0 ){
        setTimeout(()=>{
          bus.$emit(this.$props.data.on_select_event_emit_bus_key,{val:d})
        },500)
      }
      if(typeof this.$props.data.event_emit_bus_key == "string" && this.$props.data.event_emit_bus_key.length > 0 ){
        setTimeout(()=>{
          bus.$emit(this.$props.data.event_emit_bus_key,{val:d})
        },500)
      }
      if(this.page_controller_on_select){
        this.page_controller_on_select(d)
      }
    },
    getOption(name, def) {
      if (typeof this.$props.option[name] == "undefined") {
        return def;
      }
      return this.$props.option[name];
    },

    onReceiveEvents(e, data) {
      debug_select("onReceiveEvents my id ",this.$props.data.id,"Event",e,"Data",data)
      if (e.mode == "select_only") {
        debug_select("RECEIVING '", this.$props.data.id, "' set only '", data.allow, "' as requested by '", e.name,"'");
        this.forced_options = data.allow;
        if (data.allow && data.allow.length == 1 && data.allow[0] == "") {
          this.$store.state[this.stateCurrentRow][this.$props.data.id] = "";
          this.$store.state[this.stateCurrentEditing][this.$props.data.id] = "";
        }
      }else if(e.mode == "disable_if_value"){
        if(e.disable_if_value == data.val){
          this.localDisabled = false;
        }else{
          this.localDisabled = true;
        }
      }else if(e.mode == "disable_and_clean_if_value"){
        if(e.disable_if_value == data.val){
          if(this.localDisabled != false){
            this.$store.state[this.stateCurrentRow][this.fieldID]= this.cache_for_disable_and_clean_if_value||"";
            this.$store.state[this.stateCurrentEditing][this.fieldID]= this.cache_for_disable_and_clean_if_value||"";
          }
          this.localDisabled = false;
        }else{
          if(this.localDisabled != true){
            this.cache_for_disable_and_clean_if_value = this.$store.state[this.stateCurrentEditing][this.fieldID] || this.$store.state[this.stateCurrentRow][this.fieldID]||this.$props.data.default||"";
          }
          this.localDisabled = true;
          this.$store.state[this.stateCurrentRow][this.fieldID]= this.$props.data.default||"";
          this.$store.state[this.stateCurrentEditing][this.fieldID]= this.$props.data.default||"";
        }
      }else if(e.mode == "disable_and_set_message_if_value"){
        if(e.disable_if_value == data.val){
          if(this.localDisabled != false){
            this.$store.state[this.stateCurrentRow][this.fieldID]= this.cache_for_disable_and_clean_if_value||"";
            this.$store.state[this.stateCurrentEditing][this.fieldID]= this.cache_for_disable_and_clean_if_value||"";
          }
          this.localDisabled = false;
          this.localRefreshSequecnce++;
        }else{
          if(this.localDisabled != true){
            this.cache_for_disable_and_clean_if_value = this.$store.state[this.stateCurrentEditing][this.fieldID] || this.$store.state[this.stateCurrentRow][this.fieldID]||this.$props.data.default||"";
          }
          this.localDisabled = true;
          this.$store.state[this.stateCurrentEditing][this.fieldID]= this.$props.data.default||"";
          this.$store.state[this.stateCurrentRow][this.fieldID]= e.msg||"";
          this.localRefreshSequecnce++;
        }
      }
    },
    checkToApplySelectionRules(selected) {
      if (this.selection_rules != false) {
        debug_select("checkToApplySelectionRules for ", selected);
        this.selection_rules.forEach(rule => {
          if (rule.action == "select_only" && rule.mode == "on_select") {
            var allow = rule.options[selected] || null;
            debug_select(
              "checkToApplySelectionRules EMITING ",
              rule.event_name,
              { allow, from: this.$props.data.id }
            );
            bus.$emit(rule.event_name, { allow, from: this.$props.data.id });
          } else if (
            rule.action == "enable_if_match_or_empty" &&
            rule.mode == "on_select"
          ) {
            debug_select(
              "checkToApplySelectionRules EMITING ",
              rule.event_name,
              { selected, id: this.fieldID }
            );
            bus.$emit(rule.event_name, { selected, id: this.fieldID });
          }
        });
      }
    },
    refreshOptions() {
      var temp = _.clone(this.local_options);
      this.local_options = [];
      temp.forEach(e => {
        this.local_options.push(e);
      });
    },
    load_data(api_filter_value = false){
      var cache_key = this.fieldID;
      if(this.isSearchMode == true){
        cache_key = this.fieldID + "_for_search";
      }
      var cache = this.$store.state.cached_lists[cache_key];
      if(api_filter_value != false){
        cache =  this.$store.state.cached_lists[cache_key + api_filter_value];
      }
      // TODO: Improve it, using a TTL, but for now, just disable
      cache = false;
      if ( typeof cache != "undefined" && cache && cache != false && cache.length > 0 ) {
        this.fieldOptions = cache;
        this.originalFieldOptions = cache;
        if(typeof this.$props.data.force_select_first_option != "undefined" && this.$props.data.force_select_first_option == true){
          //TODO: this force_select_first_option is not working correclty, it is not in use by any field at moment, so will be fixed later
          this.updateValue(cache[0].val)
          this.last_search_value = cache[0].val;
        }
      } else {
        var data_obj = {}
        if(this.isSearchMode == true){
          data_obj.limit_department_on_search = false;
          if(this.$props.data.limit_department_on_search||false){
            data_obj.limit_department_on_search =  this.isNoAdminUserId && this.$props.data.limit_department_on_search;
          }
          if(this.$props.data.limit_admin_department_on_search||false){
            data_obj.limit_admin_department_on_search =  this.$props.data.limit_admin_department_on_search||false;
          }
        }else{
          if(this.$props.data.limit_department_on_load||false){
            data_obj.limit_department_on_load =  this.$props.data.limit_department_on_load||false;
          }
        }
        if(typeof this.$props.data.api_filter_bus_key == "string" && this.$props.data.api_filter_bus_key.length > 0 ){
            data_obj[this.$props.data.api_filter_bus_key] = (api_filter_value != false && api_filter_value != null)?api_filter_value:"";
        }
        if(this.$props.data.page_controller == true && this.isSearchMode != true ){
          this.fieldOptions = [];
          this.originalFieldOptions = [];
        }else{
          this.isLoading = true;
          this.$ajax.post_cached_queued(this.$props.data.api, data_obj, (err, result) => {
            var data = result
            this.isLoading = false;
            if(api_filter_value == false){
              this.$store.state.cached_lists[cache_key] = data;
            }else{
              this.$store.state.cached_lists[cache_key + api_filter_value] = data;
            }
            if(typeof this.$props.data.api_complement_array != "undefined" && Array.isArray(this.$props.data.api_complement_array)){
              this.$props.data.api_complement_array.forEach((e)=>{
                data.push(e);
              })
            }
            this.fieldOptions = data;
            this.originalFieldOptions = data;
            if(typeof this.$props.data.api_mode != "undefined"){
              if(this.$props.data.api_mode == "on_new_set_logged_user_no_edit"){
                if(this.stateIsEditingNew){
                  var user = this.currentUser;
                  this.updateValue(user)
                }
              }
            }
            if(typeof this.$props.data.force_select_first_option != "undefined" && this.$props.data.force_select_first_option == true){
              if(data && data[0] && data[0].val){
                this.updateValue(data[0].val)
              }
            }
          });
        }
      }
    },
    load_local_data(){
      this.local_data_loaded  = true;
      if(this.$props.data.page_controller != true ){
        this.load_data(false);
      }
    }
  },
  mounted() {
    // var i = 0;
    // setInterval(() => {
    //   this.$ajax.post_cached_queued("/master_user/list_user_and_team/", {"selectedCompany":"ライセンス管理窓口"}, (err, result) => {
    //   })
    // }, 2000);
    this.currentUser =Vue.localStorage.get("userID");
    this.$props.data.ref_field = this;
    if(this.isSearchMode == true || this.$props.data.pre_load_data == true){
      this.load_data(false);
    }
    if(typeof this.$props.data.api_filter_bus_key == "string" && this.$props.data.api_filter_bus_key.length > 0 ){
      bus.$on(this.$props.data.api_filter_bus_key,(data)=>{
        this.load_data(data.val);
      })
    }
    if (typeof this.$props.data.api_filter_to_other_field != "undefined"){
      if (typeof this.$props.data.api_filter_to_other_field.filter_data_on_event != "undefined" && this.$props.data.api_filter_to_other_field.filter_data_on_event.length > 0){
        if(this.$props.data.api_filter_to_other_field.disable_is_no_value == true){
          this.localDisabled = true
        }
        bus.$on(this.$props.data.api_filter_to_other_field.filter_data_on_event,(data)=>{
          if(this.$props.data.api_filter_to_other_field.disable_is_no_value == true){
            this.localDisabled =  data == "";
          }
          var temp = _.clone(this.field_options);
          this.fieldOptions = [];
          setTimeout(() => {
            this.fieldOptions = temp;
          }, 50);
        });
      }
    }
    // debug_select("mounted")
    if (
      typeof this.$props.data.selection_rules != "undefined" &&
      this.$props.data.selection_rules.length > 0
    ) {
      // debug_select("set selection_rules")
      this.selection_rules = this.$props.data.selection_rules;
    }
    if (
      typeof this.$props.data.listen_for != "undefined" &&
      this.$props.data.listen_for.length > 0
    ) {
      this.listen_for = this.$props.data.listen_for;
      this.listen_for.forEach(e => {
        // debug_select("mounted set listen_for ",e)
        bus.$off(e.name).$on(e.name, data => {
          this.onReceiveEvents(e, data);
        });
      });
    }
    if(typeof this.$props.data.listen_for_value != "undefined"){
      var bus_name = this.$props.data.listen_for_value;
      bus.$off(bus_name).$on(bus_name,(new_value)=>{
        this.updateValue(new_value); // It set the real value to edit
        this.$store.state[this.stateCurrentRow][this.fieldID] = new_value; // It set the visual value
        // var t = _.clone(this.fieldOptions);
        // this.fieldOptions = [];
        // this.fieldOptions = t;
        this.localRefreshSequecnce++;
      })
    }
    if(this.$props.data.page_controller){
      this.$props.data.page_controller_setup = (options) =>{
        this.page_controller_on_select = (v)=>{
          if(this.page_controller_disable_propagate == true){
            return ;
          }
          options.on_select(v)
        };
      }
      this.$props.data.page_controller_msg = (options) =>{
        switch (options.cmd) {
          case "enable_if_data":
            var fv = this.fieldValue
            if(fv && fv.length > 0){
              this.localDisabled = false;
            }else{
              this.localDisabled = true;
            }
            break;
          case "enable":
            this.localDisabled = false;
            break;
          case "disable":
            this.localDisabled = true;
            break;
          case "set_options":
            this.fieldOptions = [];
            _.remove(options.options,(d)=> {return d == "" || d == null})
            this.fieldOptions = options.options;
            this.originalFieldOptions = _.clone(options.options);
            if(this.page_controller_on_select && options.reset == true){
              this.page_controller_on_select("");
            }
            if(options.options && options.options[0] && this.$store.state[this.stateCurrentRow][this.fieldID] == ""){
              // this.$store.state[this.stateCurrentRow][this.fieldID] = options.options[0];
              // this.updateValue(options.options[0])
            }else{
            }
            break;
          case "set_options_kv":
            this.originalFieldOptions = _.clone(options.options);
            this.fieldOptions = _.clone(options.options);
            break;
          case "set_value":
            this.$store.state[this.stateCurrentRow][this.fieldID] = options.val;
            this.updateValue(options.val);
            this.localRefreshSequecnce++;
            break;
          // case "set_first_value":
          //   var val = "";
          //   if(this.fieldOptions && Array.isArray(this.fieldOptions) && this.fieldOptions.length > 0){
          //     val = this.fieldOptions[0]
          //   }
          //   this.$store.state[this.stateCurrentRow][this.fieldID] = val;
          //   this.updateValue(val);
          //   this.localRefreshSequecnce++;
          //   break;
          default:
            break;
        }
      }
    }
    this.$props.data.on_field_messages = (vm,msg,cb) =>{
      if(msg && msg.msg_type == "error"){
        if(msg.show_as_error_mode == false && this.showAsError == false){
          return cb(false);
        }
        this.page_controller_disable_propagate  = true;
        var local_val = _.clone(this.$store.state[this.stateCurrentEditing][this.fieldID]);
        if(typeof local_val == "undefined"){
          local_val = _.clone(this.$store.state[this.stateCurrentRow][this.fieldID]);
        }
        if(msg.show_as_error_mode && msg.only_if_enabled == true && this.isDisabled == true){
          this.showAsError = false;
          this.$store.state[this.stateCurrentRow][this.fieldID] = local_val;
          this.updateValue(local_val);
          this.localRefreshSequecnce++;
          this.page_controller_disable_propagate  = false;
          return cb(false);
        }
        this.showAsError = msg.show_as_error_mode || false;
        this.$store.state[this.stateCurrentRow][this.fieldID] = local_val;
        this.updateValue(local_val);
        this.localRefreshSequecnce++;
        this.page_controller_disable_propagate  = false;
        return cb(true);
      }
    }
  },
  beforeDestroy(){

    if(this.isSearchMode == true){
        if (typeof this.$props.data.search_option != "undefined" && typeof this.$props.data.search_option.define_department_limit_to_key != "undefined") {
          this.$store.state.define_department_limit = false;
        }
      }
    if(typeof this.$props.data.api_filter_bus_key == "string" && this.$props.data.api_filter_bus_key.length > 0 ){
      bus.$off(this.$props.data.api_filter_bus_key);
    }
    if (typeof this.$props.data.api_filter_to_other_field != "undefined" && typeof this.$props.data.api_filter_to_other_field.filter_data_on_event != "undefined" && this.$props.data.api_filter_to_other_field.filter_data_on_event.length > 0){
      bus.$off(this.$props.data.api_filter_to_other_field.filter_data_on_event);
    }
    if(typeof this.$props.data.listen_for_value != "undefined"){
      var bus_name = this.$props.data.listen_for_value;
      bus.$off(bus_name)
    }
  },
 
  props: ["data", "value", "option", "read", "search_value"]
};
</script>
<style>
.vs__selected{
  width: 50px;
}

.vs__selected-options{
  background-color: #ffffff!important;
  align-content: flex-start!important;
}
.vs__dropdown-toggle{
  white-space: nowrap!important;
  background-color: #ffffff!important;
  overflow: hidden!important;
  height: 24px!important;
  padding: 0px 0px 0px 0px!important;
  margin: 0px;
}
.vs__dropdown-menu {
  background-color: #ffffff!important;
  white-space: nowrap!important;
  width: 300px!important;
}
.vs__open-indicator{
  background-color: #ffffff!important;
  display: none!important;
}

</style>
<style scoped>

.esma_error_field {
  color:red;
}
.is_required{
  color:red;
}
.form-control[disabled],
fieldset[disabled] .form-control {
  background-color: #cccccc;

  padding: 0px 6px 0px 6px;
}
.form-control {
  color: black;
  height: 24px;

  padding: 0px 6px 0px 6px;
}
.form-control::selection {
  color: white;
  background: #575757;
}
::-webkit-input-placeholder {
  /* Edge */
  color: red;
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: red;
}

::placeholder {
  color: red;
}
</style>



// WEBPACK FOOTER //
// select-box4.vue?75dbbbc0